module.exports = "https://web-assets.ifttt.com/packs/media/ifttt_next/img-footer-web-desktop-plus-ee4ccb17.svg";